/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Single/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Single({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/ScheduleOptions/Content/SlotSelect/Content/Content/Options/Option/Single"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let groupSelectedValueData = fromData.useDataValue({ viewPath,
context: 'group',
path: 'selected',
})
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let groupTimeFormattedValueData = fromData.useDataValue({ viewPath,
context: 'group',
path: 'time_formatted',
})
let groupSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'group',
path: 'selected',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<button
  data-testid="Single.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-Z29kesn': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pr-2-Z29kesn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z29kesn': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-4-Z29kesn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-5-Z29kesn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-Z29kesn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-Z29kesn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-8-Z29kesn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-Z29kesn': isHovered ? dtColorsNeutral100 : groupSelectedValueData ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Single.Horizontal"
  data-view-path={viewPath}
 style={{'--g-10-Z29kesn': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral900}
 data="group.time_formatted"
 text={groupTimeFormattedValueData}
 weight={groupSelectedValueData1 ? "medium" : "regular"}
 data="group.selected"
/>
</div>
</button>
{children}
</React.Fragment>)
}